$(function() {
  const submitComment = function(e) {
    e.preventDefault();
    const form = $(this).closest("form");
    const entityId = form.find('input[name="entity_id"]').val();

    $.ajax({
      type: form.attr("method"),
      url: form.attr("action"),
      data: form.serialize(),
      success: function(response) {
        // Check if this is an inline comments form (feed view)
        const inlineContainer = form.closest('.inline-comments');
        if (inlineContainer.length) {
          // Dispatch event for Alpine component to handle the new comment
          window.dispatchEvent(new CustomEvent('comment-added', {
            detail: { entityId: entityId, html: response }
          }));
        } else {
          // Reply forms are nested inside .comment which is inside .comment-list.
          // Main forms are siblings of .comment-list via .comment-form-section.
          let commentList = form.closest(".comment-list");
          if (!commentList.length) {
            commentList = form.closest(".comments, .comment-form-section").parent().find(".comment-list");
          }
          commentList.removeClass("hidden").prepend(response);
        }
        form.find(".comment-input").val("");
        form.find(".comment-submit-button").addClass("hidden");
        form.find(".error-message").addClass("hidden");

        // Hide reply form after submission
        if (form.closest(".comment").length) {
          form.addClass("hidden");
        }

        // Initialize icons in new comment
        if (window.LucideIcons) {
          window.LucideIcons.initialize(document.body);
        }
      },
      error: function(response) {
        form.find(".error-message").removeClass("hidden").text(response.responseText ?? "An error occurred");
        form.find(".comment-input").focus();
      }
    });
  };

  // Use event delegation for dynamically loaded comment forms
  $(document).on("input", ".comment-input", function() {
    const submitButton = $(this).closest("form").find(".comment-submit-button");
    if ($(this).val().length > 0) {
      submitButton.removeClass("hidden");
    } else {
      submitButton.addClass("hidden");
    }
  });

  $(document).on("submit", ".comment-form", submitComment);

  $(document).on("click", ".comment-submit-button", function() {
    $(this).closest("form").submit();
  });

  $(document).on("click", ".comment-reply-button", function(e) {
    e.preventDefault();
    const comment = $(this).closest(".comment");
    const replyForm = comment.find(".comment-form");
    replyForm.removeClass("hidden");
    replyForm.find(".comment-input").focus();
  });

  // Use document.on() to bind events to elements that are not yet in
  // the DOM since language select items are added dynamically
  $(document).on("click", ".comment-delete-button", function(e) {
    e.preventDefault();
    const comment = $(this).closest(".comment");
    const deleteUrl = $(this).data("url");

    ConfirmModal.show({
      message: window.t('common.comment_delete_confirm'),
      type: 'danger',
      onConfirm: async function() {
        $.ajax({
          type: "DELETE",
          url: deleteUrl,
          headers: {
            "X-AUTH-TOKEN": await window.getApiToken()
          },
          success: function() {
            comment.remove();
          },
          error: function() {
            alert(window.t('common.comment_delete_error'));
          }
        });
      }
    });
  });
});
